import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { UserInfo } from "../../../shared/types/user-info";
import { InternalProvider } from "./internal-provider.type";
import { InternalProviderTableService } from "./internal-provider-table.service";

@Component({
  selector: "app-internal-provider",
  templateUrl: "./internal-provider.component.html",
  styleUrls: ["./internal-provider.component.scss"],
})
export class InternalProviderComponent implements OnInit {
  currentUser: UserInfo;
  tableConfig: DataTable<InternalProvider>;

  constructor(
    public internalProviderTableService: InternalProviderTableService,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  // #region Lifecycle Method

  ngOnInit(): void {
    this.tableConfig = this.internalProviderTableService.getInternalProviderTableConfig();
  }

  // #endregion

  // #region Handlers

  onAddInternalProvider = (): void => this.addInternalProvider();

  // #endregion

  // #region Private methods

  private addInternalProvider = (): void => {
    this.router.navigate(["/internal-providers/create"]);
  };

  // #endregion
}
